import { useState } from "react";

function TestPage() {
  const [answer, setAnswer] = useState(false);
  const toggleAnswer = () => setAnswer(!answer);


  return (
    <>
      <div>
        <input type="radio" value={true} name="option" onClick={toggleAnswer} />
        <span>Oui</span>
        <input type="radio" value={false} name="option" onClick={toggleAnswer} /> <span>Non</span>
      </div>
      {answer ? <div>You said yes! </div> : <div>You said no! </div>}

    </>
  );
}

export {TestPage};